module.exports = __webpack_public_path__ + "static/img/banner_02.15ae4e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner_02.png
// module id = rcIB
// module chunks = 1